import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appExpandableDomElement]'
})
export class ExpandableDomElementDirective {

  @HostBinding('class.toggled') toggled: boolean = true;

  constructor() { }

  @HostListener("click")
  toggle(){
    this.toggled = !this.toggled;
  }

}
